var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCycloneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 150,
    viewBox: "0 0 139 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.1009 75.378C73.3614 72.773 76.1346 71.1763 80.9245 71.1763C89.3279 71.1763 94.9581 75.8827 94.9581 87.3953C94.9581 98.9079 87.311 108.992 71.5127 108.992C52.269 108.992 42.7732 95.2942 42.7732 77.6471C42.7732 59.0756 56.0505 38.6553 82.6052 38.6553C109.16 38.6553 128.572 57.7314 128.572 85.2944C128.572 115.967 107.647 140.252 71.5127 140.252C31.0925 140.252 9.91598 111.177 9.91598 75.9668C9.91598 42.9416 32.7732 15.7978 66.3866 9.99952C69.832 9.41129 71.6808 7.6467 71.6808 4.87359C71.6808 1.84837 69.832 0 66.7228 0C46.5547 0 0 25.1263 0 75.8827C0 115.21 25.6303 150 71.5127 150C112.857 150 138.404 120.168 138.404 85.2103C138.404 52.6893 112.773 28.7399 82.6052 28.7399C50.5043 28.7399 32.9412 55.0419 32.9412 77.563C32.9412 100.084 46.7228 118.74 71.5127 118.74C92.7732 118.74 104.79 102.941 104.79 87.3112C104.79 70.3363 93.4455 61.1768 80.9245 61.1768C70.6724 61.1768 62.0169 67.5629 62.0169 76.4705C62.0169 79.4957 63.7816 81.5123 66.5547 81.5123C69.9161 81.5123 70.6724 78.2351 72.0169 75.2939L72.1009 75.378Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycloneIcon);
export default __webpack_public_path__ + "static/media/cyclone-icon.a8b6d82556e4bd0ce4f0846a754e5541.svg";
export { ForwardRef as ReactComponent };